import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { cardsService } from "./cardsService";

export const getCardLimits = async (
  cardId: string
): Promise<cardApiSpec.GetCardLimitsResponse> => {
  const { data } = await cardsService.get(`${cardId}/limits`);

  return data;
};
